import React, { useEffect, useState } from 'react';

import { getPeriodsRequest } from '../../../../api/requests/periods';
import NewRefundModal from '../Refunds/components/NewRefundModal';
import { useStudentCurrentAccountLoader } from '../components/StudentCurrentAccountLoader';
import { getChargeItems } from './api';
import DebtActionRow from './components/DebtActionRow';
import DebtFilters, { PeriodFilterItem } from './components/DebtFilters';
import DebtHeader from './components/DebtHeader';
import DebtLoader, { useDebtLoader } from './components/DebtLoader';
import DebtTable from './components/DebtTable';
import NewChargeModal from './components/NewChargeModal';
import { ChargeItem } from './types';

function DebtContent() {
  const [isNewChargeOpen, setIsNewChargeOpen] = useState(false);
  const [isNewRefundOpen, setIsNewRefundOpen] = useState(false);
  const [refundsRefreshToken, setRefundsRefreshToken] = useState(0);
  const { data: studentData } = useStudentCurrentAccountLoader();
  const { refresh } = useDebtLoader();

  const [chargeItems, setChargeItems] = useState<ChargeItem[]>([]);
  const [periods, setPeriods] = useState<PeriodFilterItem[]>([]);

  useEffect(() => {
    getChargeItems().then((res) => {
      if (res.data) setChargeItems(res.data);
    });
    getPeriodsRequest(100, 0).then((res) => {
      if (res.data) {
        setPeriods((res.data.data as unknown) as PeriodFilterItem[]);
      }
    });
  }, []);

  return (
    <>
      <DebtHeader />
      <DebtFilters periods={periods} />
      <DebtActionRow
        onOpenNewChargeModal={() => setIsNewChargeOpen(true)}
        onOpenNewRefundModal={() => setIsNewRefundOpen(true)}
      />
      <DebtTable refundsRefreshToken={refundsRefreshToken} />
      <NewChargeModal
        isOpen={isNewChargeOpen}
        onClose={() => setIsNewChargeOpen(false)}
        studentId={studentData!.studentId}
        chargeItems={chargeItems}
        onSuccess={() => {
          setIsNewChargeOpen(false);
          refresh();
        }}
      />
      {studentData?.studentId != null && (
        <NewRefundModal
          isOpen={isNewRefundOpen}
          onClose={() => setIsNewRefundOpen(false)}
          studentId={studentData.studentId}
          onSuccess={() => {
            setIsNewRefundOpen(false);
            refresh();
            setRefundsRefreshToken((v) => v + 1);
          }}
        />
      )}
    </>
  );
}

function Debt() {
  return (
    <DebtLoader>
      <DebtContent />
    </DebtLoader>
  );
}

export default Debt;
